import { CSSProperties } from 'react';
import './LoadingImages.css';

interface ILoading {
  style?: CSSProperties;
  loadingContainerClass?: string;
}

export default function LoadingImages({style, loadingContainerClass}: ILoading) {
  return (
    <div style={style} className={`image-spinner-container ${loadingContainerClass ? loadingContainerClass : ''}`}>
      <div className='image-spinner'></div>
      <div>Loading...</div>
    </div>
  )
}